import Tone from 'tone';
import ipfs from "decentralized/Ipfs.js";
import {sleep} from "utils/sleep.js"
import Preset from "repos/Preset.js";
import Formants from './Formants.js';
import {setEffectParameterValues} from 'actions/index.js';
import Formant from './Formant.js';
import {AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import ethereum from "decentralized/ethereum.js";

const presets = ethereum.presets;
const NUMBER_FORMANTS = 8;
export default superclass => class extends superclass  {

    async loadFormantsPreset(preset) {
        let {contentHash} = preset;
        let json = await ipfs.getJson(contentHash);
        if (Array.isArray(json)) {
            json = {
                formants: json
            };
        }

        this.preset = new Preset();
        this.preset.contentHash = contentHash;

        let instrument = this.instrument;
        let release;
        if (instrument) {
            release = instrument.ampEnvelope.release;
            instrument.ampEnvelope.release = 100;
            instrument.clearVoiceData();
            instrument.loaded = false;
            instrument.track.trackIsLoading = true;
            await sleep(100);
        }
        
        let bulk = {};
        let lfosTrack = instrument ? instrument.track.lfosTrack :
            this.sequencerEngine.currentSubSequence.lfosTrack;
        let envelopesTrack = instrument ? instrument.track.envelopesTrack :
            this.sequencerEngine.currentSubSequence.envelopesTrack;
        if (json.lfos) {
            let i=0;
            for (let {lfo} of lfosTrack.lfos) {
                bulk = {
                    ... bulk,
                    ...lfo.fromJson(json.lfos[i++], true)
                };
            }
        }
        if (json.envelopes) {
            let i=0;
            for (let {envelope} of envelopesTrack.envelopes) {
                bulk = {
                    ...bulk,
                    ... envelope.fromJson(json.envelopes[i++], true)
                };
            }
        }
        for (let i=0; i < this.formants.length; i++) {
            let formant = this.formants[i];
            bulk = {... bulk, ...formant.fromJson(json.formants[i], true)};
        }

        let track = instrument ? instrument.track : this.track;
        track.sequencerEngine.dispatch(
            setEffectParameterValues(bulk));
        if (instrument) {
            instrument.loaded = true;
            instrument.track.trackIsLoading = false;
            instrument.ampEnvelope.release = release;
        }
    }

    saveFormantsAsPreset(name) {
        let instrumentType = "formants";
        let json = {
            envelopes: this.instrument.track.envelopesTrack.envelopes.map(
                env => env.getJson()),
            lfos: this.instrument.track.lfosTrack.lfos.map(
                lfo => lfo.getJson()),
            formants: this.formantsManager.formants.map(
                x => x.getJson(true))
        };
        presets.newPreset(json, name, undefined, instrumentType, 0).then(
            x => {
                this.preset = new Preset();
                this.preset.contentHash =  x;
                this.preset.name = name;
                console.log("returned x=", x);
            });
    }

    get formants() {
        return this.formantsManager.formants;
    }

    setupFormants(reload=false) {
        this.formantsManager = new Formants(this);
        /*
        if (!reload) {
            // create the formants

            this.formants = [];
            for (let i=0; i < NUMBER_FORMANTS; i++) {
                this.formants.push(new Formant(this, i));
            }
        } else {
            // we are reloading (i.e. the poly changed and we spawned a new
            // synth). So we need to hook up all the parameters to their
            // audio params once again
            this.formants.forEach(s => s.setup(true));
        }
        */
    }

    initializeFormants(voices=this.voices) {
        /*
        for (let voice of voices) {
            if (voice.formantsFilter !== undefined) {
                // we've already made it
                continue;
            }
            
            voice.envelope.disconnect(voice.output);
            voice.formantFilters = [];
            voice.formantGains = [];
       }
       */
    }

    copyFormants(voice, initialize=false) {
        // we have a new voice and we want to make sure the formants are on this one too
        /*
        if (initialize || this.formants.some(formant => formant.enabledParameter.get())) {
            this.initializeFormants([voice]);
        }
        for (let formant of this.formants) {
            if (!formant.enabledParameter.get()) {
                continue;
            }

            // its enabled so we need to initialize and connect
            formant.connectToSynth([voice]);
            formant.refreshParameters();
        }
        */
    }

    voiceHasFormant(voice) {
        return voice.formantFilters !== undefined;
    }

    destroyFormants(synth=this, reconnect=true, disconnectParameters=true) {
    }

    getFormantsJson(isPreset) {
        return this.formants.map(formant => formant.getJson(isPreset));
    }

    loadFormantsJson(json, ignoreId) {
        this.formants.forEach(x => x.ripMods());
        if (Tone.Master.context.isOffline) {
            let bulk = {};
                for (let i in json) {
                    bulk = {... bulk, ...this.formants[i].fromJson(json[i], ignoreId)};
                }
            return bulk;
        } else {
            let bulk = {};
            let loaded = [];
            for (let i in json) {
                loaded.push(this.formants[i]);
                bulk = {... bulk, ...this.formants[i].fromJson(json[i], ignoreId)};
            }
            let toKill = this.formants.filter(x => !loaded.includes(x));
            toKill.forEach(
                x => {
                    x.bypassEffect();
                    x.bypass();
                });
            
            return bulk;
        }
    }
}
